import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta-video",
  "use": "icon-arrow--cta-video-usage",
  "viewBox": "0 0 7 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 7 9\" id=\"icon-arrow--cta-video\"><path d=\"M6.625 4.282a.25.25 0 0 1 0 .433l-6 3.464a.25.25 0 0 1-.375-.216V1.034A.25.25 0 0 1 .625.818l6 3.464Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol